import { createRatingStars } from '@/service/creators/createRatingStars';

type TRatingStarsProps = {
    rating: string;
    count: string;
    className?: string;
};

const STARS = {
    full: '/icon/StarFull.svg',
    half: '/icon/StarHalf.svg',
    empty: '/icon/StarEmpty.svg',
};

const Star = ({ type }: { type: 'full' | 'half' | 'empty' }) => {
    return <img src={STARS[type]} alt="Star" />;
};

export const RatingStars = ({ rating, className, count }: TRatingStarsProps) => {
    if (!+count) {
        return <></>;
    }

    const { full, half } = createRatingStars(rating);

    if (full + half < 1 || full + half > 5) {
        return <></>;
    }

    return (
        <div
            className={`flex h-[10px] w-[62px] justify-between ${className || ''}`}
            data-test-id="rating-stars"
        >
            {Array.from({ length: 5 }, (_, i) => {
                if (i < full) {
                    return <Star type="full" key={i} />;
                }
                if (i === full && half === 1) {
                    return <Star type="half" key={i} />;
                }
                return <Star type="empty" key={i} />;
            })}
        </div>
    );
};
